import React from 'react';
import TextField from './TextField';

/**
 * Reusable Email Input Field Component
 * Specialized email field with validation
 * 
 * @param {boolean} readOnly - Whether field is read-only
 * @param {string} placeholder - Custom placeholder text
 * @param {object} ...props - Additional props passed to TextField
 */
const EmailField = ({ 
  readOnly = false, 
  placeholder = "e.g john.doe@example.com",
  ...props 
}) => (
  <TextField
    name="email"
    label="Email"
    placeholder={placeholder}
    type="email"
    required
    readOnly={readOnly}
    rules={[
      { type: 'email', message: 'Please enter a valid email address' },
      { min: 5, message: 'Email must be at least 5 characters' },
      { max: 100, message: 'Email must not exceed 100 characters' }
    ]}
    {...props}
  />
);

export default EmailField;
